<template>
  <div class="nippai-components">
    <MyModal @close="closeModal" v-if="modal">
      <!-- default スロットコンテンツ -->
      <div class="iframe-wrapper">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/do2T0T_9eTg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
      <!-- /default -->
    </MyModal>
    <div class="nippai">
      <div class="head-wrapper">
        <div class="jumbotron">
          <img src="../../assets/img/job/nippai/jumbotron.jpg" alt="" class="over_display">
          <img src="../../assets/img/job/nippai/jumbotron_under.jpg" alt="" class="under_display">
        </div>
        <div class="message-tile">
          <div class="message-tile-inner">
            <div class="message">
              <img src="../../assets/img/job/nippai/catch.png" alt="食卓の名脇役に光を。常連さんと、あれこれ盛り上がる毎日です。" width="390px">
            </div>
            <div class="movie-button" @click="openModal">
              <img src="../../assets/img/job/movie_button.png" alt="1分で仕事を見る" width="360px">
            </div>
          </div>
        </div>
      </div>
      <div class="main-contents">
        <div class="type-section">
          <FukidashiTitle title="どんなタイプの先輩がいる？" />
          <TypeAnswer genre="nippai" message="派手に目立つより、<br>堅実に毎日を過ごしたい人。"/>
        </div>
        <div class="type-section">
          <FukidashiTitle title="1日でお客様と接する時間は？" />
          <Graph graphNumber="80" />
          <div class="details">
            <p>
            日配部は基本、毎日仕入れがある商品を取り扱います。たとえば、豆腐、納豆、かまぼこのような練り物、お漬け物など。どれもメインのおかずではありませんが、家庭の食卓を脇役として支えている商品です。それと冷凍食品も手掛けています。
            </p>
            <p>
            デイリーで訪れる方が多いから、売場に変化をつける季節感を演出したディスプレイづくりは大切です。幅広い商品を補充していくので、1日の8割ほどは売場で過ごし、お客様と会話する機会も豊富です。声を掛けてくださる常連のお客様はとても多いです。毎日欠かせない商品なので、よりお客様と身近でいられるのだと思います。
            </p>
            <p>
            電気・ガス・水道のように、あってあたりまえの商品をきちんと揃えてお客様をお迎えする。そんな日配部は、派手さよりも、堅実さを大切にする方に向いている気がします。
            </p>
          </div>
        </div>
        <ScheduleLink />
      </div>
    </div>
  </div>
</template>

<script>
import MyModal from '@/components/MyModal.vue'
import FukidashiTitle from '@/components/job/FukidashiTitle.vue'
import TypeAnswer from '@/components/job/TypeAnswer.vue'
import Graph from '@/components/job/Graph.vue'
import ScheduleLink from '@/components/job/ScheduleLink.vue'
export default {
  name: 'Nippai',
  components: {
    MyModal,
    FukidashiTitle,
    TypeAnswer,
    Graph,
    ScheduleLink
  },
  data() {
    return {
      modal: false,
    }
  },
  methods: {
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false
    },
  }
}
</script>
<style scoped lang="scss">
.iframe-wrapper{
  position: relative;
  width: 100%;
  height: 0;
  padding-top: 56%;
  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
.nippai {
  padding-bottom: 100px;
  margin: 0 auto;
  &:before {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    left: 0;
    top: 800px;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
  &:after {
    content: "";
    position: fixed;
    width: 80%;
    height: 500px;
    display: block;
    transform: skew(0deg, -25deg);
    right: 0;
    top: 0;
    z-index: -1;
    background-image: linear-gradient(0deg,	#f0f0f0 25%,transparent 25%,transparent 50%,#f0f0f0 50%,#f0f0f0 75%,transparent 75%,transparent);
    background-size: 120px 120px;
  }
}
.head-wrapper {
  position: relative;
}
.jumbotron {
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
}
.message-tile {
  position: absolute;
  display: flex;
  top: 0;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  width: 100%;
  transform: translateX(-40px);
  max-width: 1300px;
  width: 100%;
  left: 0;
  margin: auto;
  right: 0;
  @media print, screen and (max-width: 960px) {
    width: 50%;
    right: 0;
    left: unset;
    transform: translateX(-5px);
  }
}
.message-tile-inner {
  position: relative;
}
.movie-button {
  position: absolute;
  bottom: 30px;
  right: -30px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  @media print, screen and (max-width: 960px) {
    right: -5px;
  }
  &:hover {
    opacity: 0.5;
  }
  img {
    vertical-align: middle;
  }
}
.main-contents {
  margin: 0 auto;
  margin-top: 100px;
  max-width: 750px;
  width: 100%;
  @media print, screen and (max-width: 750px) {
    width: 90%;
  }
}
.type-section + .type-section {
  margin-top: 100px;
}
.details {
  font-size: 12px;
  line-height: 2em;
  margin-top: 50px;
}
</style>
